// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/amp","css/main.dev"], function() { return __webpack_require__("./js/src/geolocation.js"); })
__webpack_require__.O(undefined, ["css/amp","css/main.dev"], function() { return __webpack_require__("./sass/main.scss"); })
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/amp","css/main.dev"], function() { return __webpack_require__("./sass/amp.scss"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
